import LocalParkingIcon from '@mui/icons-material/LocalParking'
import MapIcon from '@mui/icons-material/Map'

import { Box, Tab, Tabs } from '@mui/material'
import { useDispatch } from 'react-redux'
import { Link, useLocation } from 'react-router-dom'
import { changeFooterLink } from '../../../state/navigation'
import { pallete } from '../../../theme'

const sx = {
  container: {
    position: 'sticky',
    zIndex: 100,
    height: '50px',
    top: 0
  },
  tabs: {
    background: pallete.headerTransparentColor,
    '& .Mui-selected': {
      color: `${pallete.paperColor} !important`
    },
    '@media (max-width: 350px)': {
      width: '100% !important',
      minWidth: '100% !important',
      maxWidth: '100% !important'
    }
  }
}

const paths = ['/map/consite', '/map/parking']

export const MapMenu = () => {
  const location = useLocation()
  const dispatch = useDispatch()

  const selected = paths.indexOf(location.pathname) >= 0
    ? paths.indexOf(location.pathname)
    : 0

  const handleChange = (_e, value) => {
    dispatch(changeFooterLink({ map: paths[value] }))
  }

  return (
    <Box sx={sx.container}>
      <Tabs
        aria-label="map menu tabs"
        value={selected}
        onChange={handleChange}
        sx={sx.tabs}
      >
        <Tab component={Link} to="/map/consite" icon={<MapIcon />} />
        <Tab component={Link} to="/map/parking" icon={<LocalParkingIcon />} />
      </Tabs>
    </Box>
  )
}
